import React from "react";
import { useLocation } from "react-router";
import { useMenu } from "../contexts/MenuContext";

import Header from "./Header";
import Loader from "../Components/Loader";

import styles from "./Layout.module.scss";
import { Outlet } from "react-router-dom";

const screensWithHeader = ["pay", "success", "login", "order", "status"];

const Layout: React.FC = (props: any) => {
  const { loading } = useMenu();
  const location = useLocation();

  const paths = location.pathname.split("/").filter((p) => p);

  const showHeader =
    screensWithHeader.indexOf(paths[paths.length - 1]) > -1 ||
    screensWithHeader.indexOf(paths[2]) > -1;
  const isMenuRoute = paths.includes("menu");
  const isOrderRoute = paths.includes("order");
  const isLocationRoot =
    paths[0] === "location" &&
    !paths.includes("menu") &&
    !paths.includes("order") &&
    !paths.includes("status");

  return (
    <div
      className={`${styles.Layout} ${isMenuRoute ? styles.MenuLayout : ""} ${isOrderRoute ? styles.OrderLayout : ""} ${isLocationRoot ? styles.LocationRootLayout : ""}`}
    >
      {showHeader && <Header back />}
      <main className={styles.Main}>{loading ? <Loader /> : <Outlet />}</main>
    </div>
  );
};

export default Layout;
